import React from 'react';
import './index.less';
import { Alert } from '@jd/jmtd';

export default function CommonNoAccess(props) {
  const errorMessage = (
        <span>
            您没有该页面数据权限，可尝试<a href='http://ge.jd.com/auth/gep/view/authorManagement/authorApply' target='_blank'>申请权限</a>，如有疑问可联系 <a href='timline://chat/?topin=xn.ge.'>黄金眼小可爱</a>
        </span>
  );
  return (
    <>
      <div className="no-access-con">
        <Alert
          title={errorMessage}
          type='danger'
        />
      </div>
    </>)
}